import { AppShell } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { HeaderTabs } from "@/features/dashboard/_components/Header";
import { Role } from "@/store";

export const Route = createFileRoute("/_private/dashboard/_trucks")({
  component: RouteComponent
});

enum MenuItem {
  TRUCKS = "Caminhões",
  BRANDS = "Marcas",
  MODELS = "Modelos",
  LOAD_HISTORY = "Histórico de Carregamentos"
}

function RouteComponent() {
  return (
    <>
      <AppShell.Header>
        <HeaderTabs
          items={[
            { children: MenuItem.TRUCKS, to: "/dashboard/caminhoes" },
            { children: MenuItem.BRANDS, to: "/dashboard/caminhoes/marcas", allowed: [Role.Administrador] },
            { children: MenuItem.MODELS, to: "/dashboard/caminhoes/modelos", allowed: [Role.Administrador] },
            { children: MenuItem.LOAD_HISTORY, to: "/dashboard/caminhoes/carregamentos", allowed: [Role.Administrador] }
          ]}
          from="/dashboard/caminhoes"
        />
      </AppShell.Header>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </>
  );
}
